import React from 'react';
import { observer } from 'mobx-react-lite';
import { PopupWrapper, CloseIconWrapper, PopupLabel, PopupText } from 'src/domains/layouts/shared/popup/popups/cms/Popup.style';
import { Button } from '../../../buttons/Button';

interface SuccessPopupPropsType {
    itemLabel: string;
    handleHidePopup: () => void;
}

export const SuccessPopup = observer(({ itemLabel, handleHidePopup }: SuccessPopupPropsType) => {
    return (
        <PopupWrapper>
            <CloseIconWrapper onClick={handleHidePopup}/>
            <PopupLabel>Success!</PopupLabel>
            <PopupText>You have created a new {itemLabel}.</PopupText>
            <Button size='big' version='secondary' onClick={handleHidePopup} dataTest='continue-button'>Continue</Button>
        </PopupWrapper>
    );
});
